import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AsbestosAbatementPage from '../pages/services/asbestos/page';
import AboutPage from '../pages/about/page';
import ColoradoSpringsPage from '../pages/locations/colorado-springs/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services/asbestos-abatement',
    element: <AsbestosAbatementPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/locations/colorado-springs',
    element: <ColoradoSpringsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;